import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";
import type {
  AddNotificationTemplate,
  INotificationTemplateSearchOptions,
} from "@src/views/apps/platform-configuration/notification-templates/types";

export class NotificationTemplateService {
  async getNotificationTemplates(query?: INotificationTemplateSearchOptions) {
    return apiService.get("/notification-templates", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getNotificationTemplateDetails(id: string | number) {
    return apiService.get(`/notification-templates/${id}`);
  }

  async addNotificationTemplate(data: AddNotificationTemplate) {
    return apiService.post("/notification-templates", data);
  }

  async updateNotificationTemplate(
    id: string | number,
    data: Partial<AddNotificationTemplate>
  ) {
    return apiService.put(`/notification-templates/${id}`, data);
  }

  async deleteNotificationTemplate(id: string | number) {
    return apiService.delete(`/notification-templates/${id}`);
  }
}

export const notificationTemplateService = new NotificationTemplateService();
